<template>
  <div class="float-left ml-3 card-chat-booking" v-if="message.bookingData">
    <div class="card">
      <div class="card-body">
        <b>{{ message.text }}</b>
        <hr>
        <section class="mt-2">
          <div class="row no-gutters">
            <label class="col-4">บริการ:</label>
            <div class="col-8">
            <span v-if="message.bookingData.service.id === 1 || hasServiceItems">
              {{ message.bookingData.service | multiLangName }}
            </span>
            <span v-else>
              {{ globalState.services[message.bookingData.service.parent_id] | multiLangName }}<br>{{ message.bookingData.service | multiLangName }}
            </span>
            </div>
          </div>
          <div class="row no-gutters" v-if="message.bookingData.service.id != 1 && message.bookingData.service_items">
            <label class="col-4">รายการ:</label>
            <div class="col-8">
              <div v-for="serviceItem in message.bookingData.service_items">
                {{ getServiceItemName(serviceItem.id) }}: {{ serviceItem.quantity }} {{ getServiceItemUnit(serviceItem.id) }}
              </div>
            </div>
          </div>
          <div class="row no-gutters mt-2">
            <label class="col-4">วันที่รับบริการ:</label>
            <div class="col-8">
              <div v-if="preBookingData && preBookingData.package_type">
                <span class="text-orange">
                  <i class="fal fa-layer-group"></i> {{ $t('message.my_reservations.package') }}
                </span>
                <span> - {{ preBookingData.package_type | multiLangName }}</span>
                <span v-if="preBookingData.package_type.category === 'flexible'">
                {{ $t('message.booking.new_booking.package_count', { count: preBookingData.package_type_discount.booking_qty }) }}
              </span>
                <div v-else-if="preBookingData.package_type.category === 'unlimited'">
                  {{ $t('message.booking.new_booking.package_count', { count: preBookingData.multi_dates_times.length }) }}
                  <section class="mt-2 pb-0 mb-0">
                    <ul class="ml-4 pb-0 mb-0">
                      <li class="text-order-title" v-for="selectedDateTime in preBookingData.multi_dates_times">
                        {{ selectedDateTime | shortDate }} • {{ selectedDateTime | onlyTime }}
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
              <div v-else>
              <span v-if="Number(message.bookingData.is_no_datetime_booking) === 0">
                {{ message.bookingData.cleaning_date | prettyDate }}
              </span>
                <span class="text-orange" v-else>
                {{ $t('message.booking.new_booking.booking_type_flexible') }}
              </span>
              </div>
            </div>
          </div>

          <div class="row no-gutters mt-2" v-if="message.bookingData.service.id === 1">
            <label class="col-4">ระยะเวลา:</label>
            <div class="col-8">
              {{ message.bookingData.work_hour }} {{ $tc('message.hour', Number(message.bookingData.work_hour)) }}
            </div>
          </div>

          <div class="row no-gutters mt-2" v-if="message.bookingData.professional">
            <label class="col-4">ผู้ให้บริการ:</label>
            <div class="col-8">
              <img :src="message.bookingData.professional.full_picture" alt="" class="rounded-circle mr-2" width="40">
              {{ message.bookingData.professional.full_name | firstName }}
            </div>
          </div>

          <div class="row no-gutters mt-2">
            <label class="col-4">ที่อยู่:</label>
            <div class="col-8">
              <b>{{ message.bookingData.user_place.place_name }}</b>
              <div>{{ message.bookingData.user_place.address }}</div>
              <span v-if="message.bookingData.user_place.district">{{ message.bookingData.user_place.district | multiLangName }}</span>
              <span v-if="message.bookingData.user_place.address_province">{{ message.bookingData.user_place.address_province | multiLangName }}</span>
            </div>
          </div>

          <div class="row no-gutters mt-2" v-if="message.bookingData.remark">
            <label class="col-4">หมายเหตุ:</label>
            <div class="col-8">
              {{ message.bookingData.remark }}
            </div>
          </div>

          <!-- Warning no location of user place -->
          <div>
            <div class="d-flex border border-warning justify-content-start align-items-top -bg-warning-soft rounded-all p-2 my-2 text-small"
                 v-if="!hasLocation">
              <div>
                <i class="fal fa-exclamation-circle text-danger fa-lg"></i>
              </div>
              <div class="pl-2">
                {{ $t('message.booking.contact_step.no_location_warning') }}
              </div>
            </div>
            <div>
              <label>{{ $t('message.booking.contact_step.location') }}:</label>
              <div class="card my-0 border-divider text-small">
                <div class="card-body p-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="flex-fill">
                      <span v-if="hasLocation">
                        <i class="fal fa-check-circle text-success fa-lg"></i>&nbsp;&nbsp;{{ $t('message.booking.contact_step.pinned_location') }}
                      </span>
                      <span v-else>
                        <i class="fal fa-exclamation-circle text-danger fa-lg"></i>&nbsp;&nbsp;{{ $t('message.booking.contact_step.unpinned_location') }}
                      </span>
                    </div>
                    <div>
                      <button class="btn btn-sm btn-outline-info" @click="openPinlocationModal()">
                        {{ hasLocation ? $t('message.button.edit') : $t('message.button.add') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters mt-2" v-if="customerPhotoUrls">
            <label class="col-4">
              {{ $t('message.booking.checkout_step.customer_area_photos') }}
            </label>
            <div class="col-8">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="0"
                controls
                indicators
                background="#ababab"
                img-height="150"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide :img-src="imageUrl" v-for="imageUrl in customerPhotoUrls"></b-carousel-slide>
              </b-carousel>
            </div>
          </div>

          <!-- Checkout cost -->
          <checkout-cost @onChangedCostData="updateCostData"/>
          <hr>
          <div v-if="isExpired">
            <div class="pb-3 text-small">
              <i class="fa fa-exclamation-triangle -status-alert"></i>
              ไม่สามารถดำเนินการชำระเงินได้ เนื่องจากเวลาที่คุณต้องการใช้บริการค่อนข้างกระชั้น กรุณาทำรายการจองใหม่
            </div>
            <button class="btn btn-outline-info btn-block" @click="newBooking()">ทำการจองใหม่</button>
          </div>
          <div v-else>
            <div class="card" v-if="hasServiceItems">
              <div class="card-body text-info text-small">
                {{ $t('message.service_item.checkout_remark') }}
              </div>
            </div>

            <label class="mb-0">กรุณายอมรับเงื่อนไขการให้บริการก่อนชำระเงิน</label>
            <div class="mt-3 custom-control custom-checkbox text-small">
              <input :id="`acceptTerms_${randomInitKeyInput}`"
                     type="checkbox"
                     :name="`acceptTerms_${randomInitKeyInput}`"
                     class="custom-control-input"
                     v-model="acceptTerms">
              <label :for="`acceptTerms_${randomInitKeyInput}`" class="custom-control-label">
                {{ $t('message.booking.checkout_step.accept_conditions01') }}
                {{ $t('message.booking.checkout_step.accept_conditions02') }}
                {{ $t('message.booking.checkout_step.accept_conditions03') }}
                {{ $t('message.booking.checkout_step.accept_conditions05') }}
                <a href="/term" target="_blank">
                  <u>{{ $t('message.booking.checkout_step.learn_more') }}</u>
                </a>
              </label>
            </div>
          </div>
        </section>
        <div class="text-danger text-center pt-4" v-if="acceptTerms && !hasLocation">
          <i class="fas fa-exclamation-circle"></i> กรุณาระบุตำแหน่งที่พักก่อนดำเนินการชำระเงิน
        </div>
      </div>
    </div>

    <!-- Payment methods -->
    <section v-show="acceptTerms && hasLocation">
      <div class="card" v-if="!isExpired">
        <div class="card-body">
          <div class="pb-3" v-if="totalPrice > 20">
            <payment-methods ref="paymentMethods"
                            v-if="!qrPaymentSuccess"
                            @onSelectedPaymentMethod="updatePaymentMethod"
                            @onSelectedCreditCard="applyUserCreditCard"
                            @onRequestedSavingTempData="saveTempData"
                            @onSelectedFileUpload="setFileUpload"
                            @onSuccessQrPayment="displaySuccessDialog"></payment-methods>
            <div class="text-center" v-else>
              <i class="fas fa-check-circle -status-accepted"></i>
              {{ $t('message.success') }}
            </div>
          </div>

          <div>
            <button class="btn btn-info btn-block"
                    :disabled="isLoading"
                    v-if="displayPaymentButton"
                    @click="submitFormData()">{{ isLoading ? 'กำลังโหลด...' : 'ยืนยันการจอง' }}</button>
            <div v-if="displayContactAdmin">
              <div class="text-remark pb-3">
                <i class="fas fa-exclamation-triangle text-orange"></i>
                เวลาที่คุณต้องการใช้บริการค่อนข้างกระชั้น กรุณาติดต่อแอดมินเพื่อช่วยประสานงานหาผู้ให้บริการที่สะดวกรับงานในเวลาที่คุณต้องการ
                <span v-if="message.type !== 'booking-summary-incomplete'">หรือเปลี่ยนวันและเวลาใหม่</span>
              </div>
              <a href="https://line.me/R/ti/p/%40hnk7011n"
                target="_blank"
                class="btn btn-info btn-block">ติดต่อแอดมิน</a>
              <div class="pt-3" v-if="message.type !== 'booking-summary-incomplete'">
                <button class="btn btn-outline-info btn-block" @click="changeDateTime">เปลี่ยนวันและเวลาใหม่</button>
              </div>
            </div>
            <!-- Add buttons if incomplete booking -->
            <div class="mt-2" v-if="message.type === 'booking-summary-incomplete'">
              <div v-if="displayPaymentButton">
                <hr>
                <button class="btn btn-outline-info btn-block" @click="newBooking()">ทำการจองใหม่</button>
                <button class="btn btn-outline-info btn-block" @click="cancelBooking()">ยกเลิก</button>
              </div>
              <div class="text-center p-2" v-else>
                <i class="fas fa-check-circle -status-accepted"></i>
                {{ $t('message.success') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <snackbar ref="snackbar"
              baseSize="100px"
              :colors="{open: '#333', info: '#3DBD7D', error: '#FA7377', warn: '#FF6600'}"
              :holdTime="2500"
              :position="'bottom-center'"/>
    <!-- Pin location modal -->
    <pin-location-modal :settings="settings" ref="pinLocationModal" @savedLocation="setLocation" />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { checkoutCostMixin } from '../../../mixins/checkoutCostMixin'
  import CheckoutCost from '../../../components/booking/components/CheckoutCost'
  import PaymentMethods from '../../order/PaymentMethods'
  import packageHelpers from '../../../helpers/packageHelpers'
  import moment from 'moment-timezone'
  import chatBookingHelpers from '../../../helpers/chatBookingHelpers'
  import PinLocationModal from '../../booking/components/PinLocationModal'
  import axios from 'axios'

  export default {
    mixins: [checkoutCostMixin],
    props: {
      message: Object
    },
    components: {
      CheckoutCost,
      PaymentMethods,
      PinLocationModal
    },
    data () {
      return {
        displayContactAdmin: false,
        displayPaymentButton: true,
        discountCost: null,
        acceptTerms: false,
        randomInitKeyInput: '',
        paymentMethod: null,
        omiseCustomerId: null,
        fileUpload: null,
        isLoading: false,
        costData: null,
        qrPaymentSuccess: false,
        isExpired: false,
        slide: 0,
        sliding: null,
        settings: {
          page: 'checkout',
          hideHeaderClose: false,
          noCloseOnBackdrop: false,
          okOnly: false
        }
      }
    },
    computed: {
      ...mapGetters({
        appliedPromoCode: 'promoCode/getAppliedPromoCode',
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        preCheckoutData: 'booking/getPreCheckoutData',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['bookingData', 'tmpChatBookingCheckoutData']),
      ...mapState('promoCode', ['promoCodeValue']),
      ...mapState('booking', ['customerAreaPhotos']),
      hasServiceItems () {
        let hasServiceItems = null
        if (this.message.bookingData && this.message.bookingData.service) {
          let parentService = this.globalState.services[this.message.bookingData.service.id]
          if (parentService && parentService.has_service_items) {
            hasServiceItems = parentService.has_service_items
          }
        }
        return hasServiceItems
      },
      customerPhotoUrls () {
        if (this.message.bookingData.customer_photo_urls) {
          const photoUrls = this.message.bookingData.customer_photo_urls.split(',')
          return photoUrls
        } else {
          return null
        }
      },
      hasLocation () {
        const userPlace = this.message.bookingData.user_place
        return (userPlace.latitude && userPlace.longitude)
      }
    },
    watch: {
      appliedPromoCode () {
        if (this.appliedPromoCode) {
          const bookingCostData = this.getBookingCostData()
          this.updateChatBooking(bookingCostData, false)
          if (this.appliedPromoCode.is_applied) {
            this.displaySnackbar(this.$i18n.t('message.promo_code.you_applied_promo_code'))
          } else if (this.appliedPromoCode.promo_code.payment_method && !this.appliedPromoCode.is_applied && this.appliedPromoCode.status === 'not_matched_payment_method') {
            this.displaySnackbar(this.$i18n.t('message.promo_code.not_matched_payment_method'))
          }
        }
      },
      'preCheckoutData.is_credit': function (newVal, oldVal) {
        if (newVal) {
          const bookingCostData = this.getBookingCostData()
          this.updateChatBooking(bookingCostData, false)
        }
      },
      'costData.totalPrice': function (newVal, oldVal) {
        if (newVal === 0) {
          this.paymentMethod = 'bank_transfer'
          this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
        }
      },
      paymentMethod () {
        this.displayPaymentButton = true
        this.isLoading = false
        if (this.paymentMethod === 'promptpay') {
          this.displayPaymentButton = false
          this.submitFormData()
        }
      }
    },
    methods: {
      getServiceItemName (id) {
        if (this.globalState.services[this.message.bookingData.service_id] && this.globalState.services[this.message.bookingData.service_id].service_items) {
          const serviceItems = this.globalState.services[this.message.bookingData.service_id].service_items
          const serviceItem = serviceItems.find(item => item.id === Number(id))
          return (serviceItem) ? serviceItem.name_th : ''
        }
        return ''
      },
      getServiceItemUnit (id) {
        if (this.globalState.services[this.message.bookingData.service_id] && this.globalState.services[this.message.bookingData.service_id].service_items) {
          const serviceItems = this.globalState.services[this.message.bookingData.service_id].service_items
          const serviceItem = serviceItems.find(item => item.id === Number(id))
          return (serviceItem) ? serviceItem.item_unit.name_th : ''
        }
        return ''
      },
      setLocation (data) {
        this.message.bookingData.user_place.latitude = data.latitude
        this.message.bookingData.user_place.longitude = data.longitude
        // Save user place latitude and longitude
        const submitData = { ...this.message.bookingData.user_place }
        this.$store.dispatch('listing/SAVE_USER_PLACE', submitData)
      },
      openPinlocationModal () {
        let lat = null
        let lng = null
        let isInit = true
        if (!this.message.bookingData.user_place.latitude || !this.message.bookingData.user_place.longitude) {
          const provinceId = this.message.bookingData.user_place.province_id
          lat = this.globalState.citiesLocations[provinceId].lat
          lng = this.globalState.citiesLocations[provinceId].lng
        } else {
          lat = this.message.bookingData.user_place.latitude
          lng = this.message.bookingData.user_place.longitude
          isInit = false
        }
        this.$refs.pinLocationModal.show(lat, lng, isInit)
      },
      onSlideStart (slide) {
        this.sliding = true
      },
      onSlideEnd (slide) {
        this.sliding = false
      },
      updateCostData (costData) {
        this.costData = costData
        if (this.paymentMethod === 'promptpay') {
          this.submitFormData()
        }
      },
      displaySnackbar (message) {
        if (this.$refs.snackbar) {
          this.$refs.snackbar.open(message)
        }
      },
      getTotalPrice (bookingData) {
        const total = Number(bookingData.total_price) + Number(bookingData.service_vat)
        return total
      },
      checkPromoCodeValue () {
        let result = true
        if (this.promoCodeValue && !this.appliedPromoCode) {
          result = false
          this.$swal({text: 'คุณมีโค้ดส่วนลดที่กรอกค้างไว้อยู่ กรุณากดปุ่มใช้โค้ดเพื่อรับส่วนลดค่ะ'})
        }
        return result
      },
      getBookingCostData () {
        const bookingCostData = {
          id: this.message.bookingData.id,
          total_price: this.message.bookingData.total_price,
          service_vat: this.message.bookingData.service_vat,
          discount_cost: null,
          credit_discount_cost: null,
          promo_code_id: null,
          is_credit: 0,
          payment_method: this.paymentMethod,
          omise_customer_id: this.omiseCustomerId
        }
        let totalPriceWithVat = Number(this.subtotal)
        bookingCostData.total_price = this.subtotal
        bookingCostData.service_vat = this.serviceVat

        // Check applying promo code
        if (this.appliedPromoCode && this.appliedPromoCode.is_applied) {
          totalPriceWithVat -= Number(this.discountCost)
          bookingCostData.discount_cost = this.discountCost
          bookingCostData.promo_code_id = (this.appliedPromoCode && this.appliedPromoCode.is_applied) ? this.appliedPromoCode.id : null
        }

        // Calculate service vat
        bookingCostData.service_vat = Math.round((totalPriceWithVat * this.globalState.serviceVat) * 100) / 100
        totalPriceWithVat += bookingCostData.service_vat

        // Check using coins for discount
        if (this.preCheckoutData && this.preCheckoutData.is_credit) {
          totalPriceWithVat -= this.creditDiscountCost
          bookingCostData.credit_discount_cost = this.creditDiscountCost
          bookingCostData.is_credit = (this.preCheckoutData.is_credit) ? 1 : 0
        }
        bookingCostData.total_price_with_vat = Math.round(totalPriceWithVat * 100) / 100
        return bookingCostData
      },
      isValid () {
        if (!this.paymentMethod) {
          this.$swal({text: this.$i18n.t('message.alert.select_payment_method')})
          return false
        } else {
          switch (this.paymentMethod) {
            case 'credit_card':
              if (!this.omiseCustomerId) {
                this.$swal({text: this.$i18n.t('message.alert.select_credit_card')})
                return false
              }
              break
            case 'bank_transfer':
              if (this.totalPrice && !this.fileUpload) {
                this.$swal({text: this.$i18n.t('message.alert.no_file_upload')})
                return false
              }
              break
          }
        }
        return true
      },
      submitFormData () {
        if (this.isValid()) {
          if (this.isExpiredPayment()) {
            this.$swal({ text: 'ไม่สามารถดำเนินการชำระเงินได้ เนื่องจากเวลาที่คุณต้องการใช้บริการค่อนข้างกระชั้น กรุณาทำรายการจองใหม่' })
          } else {
            if (this.globalState.configData.checkout_acceptance) {
              let htmlContent = `<div class="text-center p-3">`
              htmlContent += `<div class="mb-4"><img src="/static/img/ic_wallet.png" class="img-fluid"></div>`
              htmlContent += `<div class="font-weight-bold mb-4">${this.$i18n.t('message.booking.checkout_step.booking_acceptance01')}</div>`
              htmlContent += `<div class="mb-4">${this.$i18n.t('message.booking.checkout_step.booking_acceptance02')}</div>`
              htmlContent += `<div class="text-info">${this.$i18n.t('message.booking.checkout_step.booking_acceptance03')}</div>`
              htmlContent += `</div>`
              this.$swal({
                html: htmlContent,
                confirmButtonColor: '#17a2b8',
                confirmButtonText: this.$i18n.t('message.button.accept')
              }).then((result) => {
                if (result) {
                  const bookingCostData = this.getBookingCostData()
                  this.updateChatBooking(bookingCostData, true)
                }
              })
            } else {
              const bookingCostData = this.getBookingCostData()
              this.updateChatBooking(bookingCostData, true)
            }
          }
        }
      },
      async updateChatBooking (bookingCostData, finishBooking) {
        if (finishBooking) {
          this.isLoading = true
        }
        if (bookingCostData.id) {
          const url = `chat-bookings/${bookingCostData.id}`
          const {data} = await axios.put(url, bookingCostData)
          if (!data.error) {
            if (finishBooking) {
              switch (this.paymentMethod) {
                case 'credit_card':
                  await this.performPayment(bookingCostData)
                  break
                case 'bank_transfer':
                  if (this.totalPrice && this.fileUpload) {
                    await this.saveBankTransferPicture(bookingCostData)
                  }
                  await this.performPayment(bookingCostData)
                  break
                case 'promptpay':
                  this.updateQrPayment()
                  break
              }
            }
          } else {
            this.isLoading = false
            if (data.failure_code) {
              let text = data.message
              if (data.failure_code === 'insufficient_credit') {
                text = this.$i18n.t('message.alert.payment_error_insufficient_credit')
              } else if (data.failure_code === 'expired_promo_code') {
                text = this.$i18n.t('message.alert.expired_promo_code')
              }
              this.$swal({
                text: text,
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: this.$i18n.t('message.button.ok')
              }).then(() => {
                this.$router.go()
              })
            } else {
              this.$swal({text: data.message, type: 'error'})
            }
          }
        }
      },
      async saveBankTransferPicture (bookingCostData) {
        const url = `chat-bookings/${bookingCostData.id}/save-bank-transfer-picture`
        let formData = new FormData()
        formData.append('file', this.fileUpload)
        const {data} = await axios.post(url, formData)
        if (data.error) {
          this.isLoading = false
          this.$swal({text: data.message, type: 'error'})
        }
      },
      async performPayment (bookingCostData) {
        const url = `chat-bookings/${bookingCostData.id}/full-order-data`
        const params = {
          payment_method: this.paymentMethod,
          omise_customer_id: this.omiseCustomerId,
          total_price: bookingCostData.total_price,
          service_vat: bookingCostData.service_vat,
          discount_cost: bookingCostData.discount_cost,
          credit_discount_cost: bookingCostData.credit_discount_cost,
          total_price_with_vat: bookingCostData.total_price_with_vat,
          is_new_cost_format: 1,
          promo_code_id: bookingCostData.promo_code_id,
          is_credit: bookingCostData.is_credit
        }
        const {data} = await axios.post(url, params)
        if (!data.error) {
          const fullOrderData = data.full_order_data
          fullOrderData.chat_booking_id = bookingCostData.id
          if (fullOrderData.package_type_id === null) {
            await this.addOrder(fullOrderData)
          } else {
            await this.addPackage(fullOrderData)
          }
        } else {
          this.isLoading = false
          this.$swal({text: data.message, type: 'error'})
        }
      },
      async addOrder (orderData) {
        const url = 'orders'
        const {data} = await axios.post(url, orderData)
        if (!data.error) {
          switch (this.paymentMethod) {
            case 'credit_card':
              await this.deleteChatBooking()
              break
            case 'bank_transfer':
              if (this.totalPrice && this.fileUpload) {
                const orderId = data.id
                await this.updateOrderBankTransfer(orderId)
              } else {
                await this.deleteChatBooking()
              }
              break
          }
        } else {
          this.isLoading = false
          this.$swal({text: data.message, type: 'error'})
          if (data.error_case && data.error_case === 'expired') {
            this.isExpired = true
            this.displayContactAdmin = true
          }
        }
      },
      async addPackage (orderData) {
        const url = 'packages'
        const {data} = await axios.post(url, orderData)
        if (!data.error) {
          switch (this.paymentMethod) {
            case 'credit_card':
              await this.deleteChatBooking()
              break
            case 'bank_transfer':
              if (this.totalPrice && this.fileUpload) {
                const order = data.order
                await this.updateOrderBankTransfer(order.id)
              } else {
                await this.deleteChatBooking()
              }
              break
          }
        } else {
          this.isLoading = false
          this.$swal({text: data.message, type: 'error'})
        }
      },
      async deleteChatBooking () {
        const url = `chat-bookings/${this.message.bookingData.id}`
        const {data} = await axios.delete(url)
        this.isLoading = false
        if (!data.error) {
          // Hide payment button when finished
          this.displayPaymentButton = false
          this.$store.commit('chatBooking/SET_TMP_CHAT_BOOKING_CHECKOUT_DATA', null)
          // Send auto reply message to user
          const message = {
            sender_type: 'user',
            type: 'text',
            label: 'success-credit-card',
            text: (this.paymentMethod === 'credit_card') ? 'ยืนยันการชำระเงินด้วยบัตรเครดิต/เดบิต' : 'ยืนยันการจอง'
          }
          this.$store.commit('chatBooking/ADD_MESSAGE', message)
        } else {
          this.$swal({text: data.message, type: 'error'})
        }
      },
      async updateOrderBankTransfer (orderId) {
        const url = `chat-bookings/${this.message.bookingData.id}/update-order-bank-transfer`
        const submitData = {
          order_id: orderId
        }
        const {data} = await axios.post(url, submitData)
        this.isLoading = false
        if (!data.error) {
          // Hide payment button when finished
          this.displayPaymentButton = false
          this.$store.commit('chatBooking/SET_TMP_CHAT_BOOKING_CHECKOUT_DATA', null)
          // Send auto reply message to user
          const bankTransfer = data.bank_transfer
          const message = {
            sender_type: 'user',
            type: 'image',
            label: 'success-bank-transfer',
            imageUrl: bankTransfer.transfer_picture
          }
          this.$store.commit('chatBooking/ADD_MESSAGE', message)
        } else {
          this.$swal({text: data.message, type: 'error'})
        }
      },
      newBooking () {
        this.displayPaymentButton = false
        const message = {
          sender_type: 'user',
          type: 'text',
          label: 'reservation',
          text: 'ทำการจองใหม่'
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      cancelBooking () {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: 'คุณต้องการยกเลิกรายการจองที่คุณทำค้างไว้อยู่ใช่หรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          const url = `chat-bookings/${this.message.bookingData.id}`
          axios.delete(url)
            .then(res => {
              const response = res.data
              if (!response.error) {
                this.$store.commit('chatBooking/INIT_MESSAGE', this.user)
              } else {
                this.$swal({text: response.message, type: 'error'})
              }
            })
            .catch(error => {
              console.log(error)
              this.$swal({text: error.message, type: 'error'})
            })
        })
      },
      changeDateTime () {
        chatBookingHelpers.replySelectDateTime()
      },
      async loadPreCheckoutData () {
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        this.$store.commit('promoCode/SET_PROMO_CODE_VALUE', null)
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        const data = this.message.bookingData
        const preBookingData = {
          province_id: data.user_place.province_id,
          service_id: data.service_id,
          work_hour: data.work_hour
        }
        // Check package booking
        if (data.package_type_id) {
          const packageType = packageHelpers.getPackageType(this.globalState.packageTypes, Number(data.package_type_id))
          let packageTypeDiscount = null
          if (packageType.category === 'flexible') {
            preBookingData.package_type = packageType
            packageTypeDiscount = packageHelpers.getPackageTypeDiscount(preBookingData.package_type, Number(data.package_type_discount_id))
            preBookingData.package_type_discount = packageTypeDiscount
          } else if (packageType.category === 'unlimited') {
            preBookingData.package_type = packageType
            preBookingData.multi_dates_times = data.selected_dates_times.split(',')
            packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(preBookingData.package_type, preBookingData.multi_dates_times.length)
          }

          // Apply promo code
          if (packageTypeDiscount) {
            const submitData = {
              user_id: this.user.id,
              promo_code: packageTypeDiscount.promo_code,
              province_id: null,
              service_id: null,
              code_type: 'package'
            }
            await this.$store.dispatch('promoCode/APPLY_PROMO_CODE', submitData)
          }
        }
        // Check service items for preBookingData using for applying promo code detecting service item
        if (data.service_items) {
          const serviceItems = []
          for (const serviceItem of data.service_items) {
            serviceItems.push({
              id: Number(serviceItem.id),
              count: Number(serviceItem.quantity)
            })
          }
          preBookingData.service_items = serviceItems
        }
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)
        const submitData = {
          user_id: this.user.id,
          user_place_id: data.user_place_id,
          province_id: data.user_place.province_id,
          service_id: data.service_id,
          work_hour: data.work_hour,
          professional_id: (data.professional) ? data.professional.id : 0
        }
        // Check service items for submitData
        if (data.service_items) {
          submitData.service_items = data.service_items
        }
        await this.$store.dispatch('booking/LOAD_PRE_CHECKOUT_DATA', submitData)
        // Check temp data of checkout when user added new credit card
        this.checkTempCheckoutData()
      },
      isExpiredPayment () {
        this.isExpired = false
        const bookingCleaningDate = this.message.bookingData.cleaning_date
        if (bookingCleaningDate) {
          const currentTime = moment(new Date())
          const cleaningTime = moment(new Date(bookingCleaningDate))
          const duration = moment.duration(cleaningTime.diff(currentTime))
          const diffMins = Math.round(duration.asMinutes())
          if (this.message.bookingData.professional_id) {
            const isSameDay = currentTime.isSame(cleaningTime, 'd')
            if (isSameDay) {
              this.isExpired = true
            } else {
              this.isExpired = (diffMins < 165)
            }
          } else {
            this.isExpired = (diffMins < 165)
          }
        }
        return this.isExpired
      },
      autoApplyPromoCode () {
        if (this.appliedPromoCode && !this.message.bookingData.package_type_id) {
          const submitData = {
            user_id: this.user.id,
            promo_code: this.appliedPromoCode.promo_code.code,
            province_id: this.preBookingData.province_id,
            service_id: this.preBookingData.service_id,
            work_hour: this.preBookingData.work_hour,
            payment_method: this.paymentMethod,
            omise_customer_id: this.omiseCustomerId
          }
          this.$store.dispatch('promoCode/APPLY_PROMO_CODE', submitData)
        }
      },
      updateQrPayment () {
        if (this.paymentMethod === 'promptpay' && this.costData) {
          const qrPaymentData = {
            paymentFor: 'normal',
            chatBookingId: this.message.bookingData.id,
            amount: Number(this.costData.totalPrice)
          }
          this.$refs.paymentMethods.updateQrPaymentData(qrPaymentData)
        }
      },
      updatePaymentMethod (paymentMethod) {
        this.paymentMethod = paymentMethod
        if (paymentMethod !== 'credit_card') {
          this.omiseCustomerId = null
          this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'payment_method', value: this.paymentMethod})
          this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {
            key: 'omise_customer_id',
            value: this.omiseCustomerId
          })
          this.autoApplyPromoCode()
        }
      },
      applyUserCreditCard (data) {
        this.paymentMethod = 'credit_card'
        this.omiseCustomerId = data.omise_customer_id
        this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'payment_method', value: this.paymentMethod})
        this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'omise_customer_id', value: this.omiseCustomerId})
        this.autoApplyPromoCode()
      },
      saveTempData () {
        const chatBookingCheckoutData = {
          appliedPromoCode: this.appliedPromoCode,
          isCredit: this.preCheckoutData.is_credit,
          acceptTerms: this.acceptTerms,
          paymentMethod: this.paymentMethod
        }
        this.$store.commit('chatBooking/SET_TMP_CHAT_BOOKING_CHECKOUT_DATA', chatBookingCheckoutData)
      },
      setFileUpload (file) {
        this.fileUpload = file
      },
      displaySuccessDialog () {
        this.qrPaymentSuccess = true
        this.$store.commit('chatBooking/SET_TMP_CHAT_BOOKING_CHECKOUT_DATA', null)
        // Send auto reply message to user
        const message = {
          sender_type: 'user',
          type: 'text',
          label: 'success-promptpay',
          text: 'ยืนยันการชำระเงินด้วยพร้อมเพย์'
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      checkTempCheckoutData () {
        // Check temp data
        if (this.tmpChatBookingCheckoutData) {
          this.acceptTerms = this.tmpChatBookingCheckoutData.acceptTerms
          if (!this.appliedPromoCode && this.tmpChatBookingCheckoutData.appliedPromoCode) {
            const currentDate = moment(new Date())
            const promoCodeExpireDate = moment(new Date(this.tmpChatBookingCheckoutData.appliedPromoCode.promo_code.expire_date))
            const duration = moment.duration(promoCodeExpireDate.diff(currentDate))
            const diffDates = Math.round(duration.asDays())
            if (diffDates >= 0) {
              this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', this.tmpChatBookingCheckoutData.appliedPromoCode)
            }
          }
          if (Number(this.preCheckoutData.total_credits) > 0 && this.tmpChatBookingCheckoutData.isCredit) {
            this.$store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'is_credit', value: true})
          }
          if (this.tmpChatBookingCheckoutData.paymentMethod && this.$refs.paymentMethods) {
            this.paymentMethod = this.tmpChatBookingCheckoutData.paymentMethod
            this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.randomInitKeyInput = Math.random().toString(36).slice(-5)
      })
      if (this.message.bookingData.cleaning_date) {
        if (this.isExpiredPayment() || this.paymentMethod === 'promptpay') {
          this.displayContactAdmin = true
          this.displayPaymentButton = false
        }
      }
    },
    created () {
      if (this.message.bookingData) {
        this.$store.commit('booking/UPDATE_TOTAL_PRICE', this.message.bookingData.total_price)
      }
      this.loadPreCheckoutData()
    }
  }
</script>

<style scoped>
.carousel {
  border-radius: 8px 8px 8px 8px;
  overflow: hidden;  
}
.carousel-inner div {
  height: 150px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/chatBooking/components/BookingSummaryMessage.vue